<template>
  <form id="step6" class @submit="sendForm">
    <loading :active="isStepLoading" :is-full-page="false" background-color="#b1b3b1">
      <div>
        <Lottie />
      </div>
    </loading>

    <h3 v-if="this.$i18n.locale === 'tr'" class="main_question text-center font-weight-normal">
      {{ $t('Nasıl ödeme yapabilirim?') }}
      <a
        id="howToPay"
        data-target="#how-to-pay-modal"
        data-toggle="modal"
        href="#"
        class="btn-outline-mukellef btn-radius ml-2 mt-2"
      >
        <i class="fa fa-play link-button-icon"></i><span>{{ $t('Videoyu İzleyin') }}</span>
      </a>
    </h3>
    <h3 class="main_question"><strong>3/3</strong>{{ $t('Ödeme') }}</h3>
    <div class="card-input">
      <div class="row" v-for="(price, index) in prices" :key="index">
        <div class="col-6">
          <div class="form-group">{{ getProductName(price) }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="form-group">
            <b v-if="price.stripe_price"
              >{{ formatPrice(Number(price.stripe_price), forceCurrency)
              }}{{
                price.type === 'subscription' ? (price.period === 'annual' ? ' / ' + $t('Yıl') : ' / ' + $t('Ay')) : ''
              }}</b
            >
            <b v-else class="free-text">{{ $t('Ücretsiz') }} </b>
          </div>
        </div>
      </div>
      <div v-if="discount" class="promotion-summary">
        <div class="row">
          <div class="col-6">
            <div class="form-group color-orange">{{ $t('İndirim Tutarı') }}</div>
          </div>
          <div class="col-6 text-right color-orange">
            <div class="form-group">
              -
              <b>{{ formatPrice(discount, forceCurrency) }}</b>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr-custom" />

      <div class="row">
        <template v-if="appliedAmount > 0">
          <div class="col-6 mt-2 color-orange mb-2">
            <div>{{ $t('affiliate.Credit Discount') }}</div>
          </div>
          <div class="col-6 text-right mt-2 color-orange">
            <div>
              <span>{{ formatPrice(Number(appliedAmount), '₺') }}</span>
            </div>
          </div>
        </template>
        <div class="col-6">
          <div class="form-group">{{ $t('Toplam Tutar (currency)', { currency: forceCurrency }) }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="form-group">
            <b>{{ formatPrice(Number(subtotal), forceCurrency) }}</b>
          </div>
        </div>
      </div>
      <Promotion
        ref="promotion"
        :companyType="companyType"
        :form="form"
        :companyId="company.id"
        :companyNationId="company.company_nation_id"
        :discount.sync="discount"
        :is-have-custom-endpoint="true"
        @custom-apply-promotion-clicked="getProducts"
        @custom-remove-promotion-clicked="getProducts"
        @apply-promotion="getProducts"
      />
      <Affiliate id="upgrade" ref="affiliate" :products="prices" @set-appliable-amount="setAppliableAmount" />
      <div class="col-12">
        <CardSelection :isHaveCards.sync="isHaveCards" :selectedCard.sync="selectedCard" />
      </div>

      <Stripe
        ref="stripe"
        :form="form"
        :company="company"
        :subtotal="subtotal"
        :currency="forceCurrency"
        :showForm="selectedCard.id === 'other' || !this.isHaveCards ? true : false"
        :appliedAmount="appliedAmount"
        v-on="$listeners"
      />
      <div class="row">
        <div class="col-12">
          <div class="form-group terms">
            <label :class="{ 'is-invalid': errors.first('commit') }" class="container_check version_2">
              <span v-html="$t('stripe_payment_policy', { link: this.privacyLink })"></span>
              <input
                v-model="form.commit"
                name="commit"
                type="checkbox"
                v-validate="'required'"
                value="false"
                class="required up"
              />
              <span class="checkmark mt-2"></span>
            </label>
            <span v-show="errors.first('commit')" class="show-invalid invalid-feedback">{{
              errors.first('commit')
            }}</span>

            <div v-if="this.$i18n.locale === 'tr'">
              <label
                :class="{ 'is-invalid': errors.first('agreement-privacy') }"
                class="container_check version_2 mt-2"
                name="ortak"
                style="padding-top: 8px"
              >
                <i18n path="home.terms_of_use.small_text" tag="span">
                  <template v-slot:privacy_text>
                    <a data-target="#privacy-global-modal" data-toggle="modal" href="#">{{
                      $t('home.terms_of_use.privacy_text')
                    }}</a>
                  </template>
                </i18n>
                <input
                  v-model="commitPrivacy"
                  type="checkbox"
                  value="false"
                  class="required up"
                  id="agreement-privacy"
                  name="agreement-privacy"
                  v-validate="'required'"
                />
                <span class="checkmark"></span>
              </label>
              <span v-show="errors.first('agreement-privacy')" class="show-invalid invalid-feedback">{{
                errors.first('agreement-privacy')
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a v-show="false" id="creditCardMessage" data-target="#accepted-credit-card-modal" data-toggle="modal" href="#" />
    <IyzicoAgreementModal />
    <FreePromotionAppliedModal />
    <AcceptedCreditCardModal />
  </form>
</template>
<script>
import IyzicoAgreementModal from '../../modals/policies/IyzicoModal';
import FreePromotionAppliedModal from '../../modals/FreePromotionAppliedModal';
import AcceptedCreditCardModal from '../../modals/AcceptedCreditCardModal';
import ProductStore from '../../../stores/product';
import CompanyStore from '../../../stores/company';
import Stripe from '@/components/Stripe';
import CardSelection from '@/components/CardSelection';
import Promotion from '../../Promotion';

export default {
  computed: {
    subtotal: function () {
      let finalPrice = 0;
      if (this.prices.length > 0) {
        finalPrice = this.prices.reduce((total, price) => total + price.stripe_price, 0);
      }

      return finalPrice - this.discount - this.appliedAmount;
    },
  },
  watch: {
    subtotal: function (val) {
      this.$emit('subtotal', { currency: this.forceCurrency, price: val });
      if (val === 0) {
        document.getElementById('freeSubscription').click();
      }
    },
  },
  data() {
    return {
      isStepLoading: false,
      appliedAmount: 0,
      acceptedCreditCardModalPassive: false,
      rate: 1,
      prices: [],
      forceCurrency: null,
      discount: 0,
      form: {
        product_id: [],
        expire: null,
        promotion_code: [],
        commit: false,
      },
      productCodes: [],
      selectedCard: {
        id: 'other',
      },
      isHaveCards: false,
      products: [],
      package: [],
      companyType: {},
      company: {},
      commitPrivacy: false,
    };
  },
  created() {
    this.startWaiting();
    CompanyStore.dispatch('getCompany').then((s) => {
      const company = s.data.data[0];
      this.company = company;
      this.virtualOffice = company.virtual_office;
      this.companyType = company.companyType.data;
      this.package = company.package;

      this.startWaiting();
      this.productCodes = this.package;
      this.getProducts(null, null, true);
    });
  },
  methods: {
    getProducts(code = null, index = null, isCreatedCall = false) {
      const appliedCodes = [...this.form.promotion_code];

      if (typeof index === 'number') {
        appliedCodes.splice(index, 1);
      }

      if (code) {
        if (!Array.isArray(code)) {
          appliedCodes.push(code);
        } else {
          code.forEach((code) => {
            appliedCodes.push(code);
          });
        }
      }

      const form = {
        product_codes: this.productCodes,
        promotion_codes: appliedCodes,
      };
      if (this.appliedAmount) {
        form.wallet_amount = this.appliedAmount;
      }

      form.appliablePromotionCode = 1;

      this.isStepLoading = true;
      $axios
        .post('register/' + this.company.id + '/basket', form)
        .then((s) => {
          this.$refs.promotion.setPromotionCodes(appliedCodes);
          const clientSecret = s.data.meta.client_secret;
          this.$refs.stripe.setIntent(clientSecret);
          const products = s.data.data;
          this.$refs.promotion.findTotalDiscount(products);
          this.productsHandler(s, isCreatedCall);
        })
        .finally(() => {
          this.isStepLoading = false;
          this.endWaiting();
        });
    },
    setAppliableAmount(data) {
      this.appliedAmount = data;
      this.$nextTick(() => {
        this.getProducts();
      });
    },
    callIntent() {
      this.$refs.stripe.getIntent();
    },
    cardMessage(e) {
      if (!this.acceptedCreditCardModalPassive) {
        window.document.getElementById('creditCardMessage').click();
        this.acceptedCreditCardModalPassive = true;
      }
    },
    optional(variable) {
      if (variable) {
        return variable;
      }

      return {};
    },
    async productsHandler(s, isCreatedCall = false) {
      this.products = s.data.data;
      this.forceCurrency = this.products[0].stripe_currency;

      if (this.forceCurrency.length > 1) {
        this.forceCurrency = this.forceCurrency + ' ';
      }

      this.prices = s.data.data;

      if (isCreatedCall) {
        const appliablePromotions = this.products.reduce(function (result, product) {
          if (product.appliable_promotion_code) {
            result.push(product.appliable_promotion_code);
          }
          return result;
        }, []);

        if (appliablePromotions.length) {
          await this.$refs.promotion.$refs.promotionModal.applyCode(appliablePromotions);
        }
      }

      this.checkAndShowErrorMessage(Number(this.subtotal).toFixed(2));

      this.endWaiting();
    },
    product(code, products) {
      if (!products) {
        return null;
      }

      return products.find(function (product) {
        return product.code === code;
      });
    },
    sendForm(callback) {
      this.$validator.validate().then((result) => {
        if (result) {
          this.startWaiting();

          /* $axios.put('reg er/' + this.company.id + '/pay', form).then((s) => {
          document
            .getElementsByTagName('body')[0]
            .insertAdjacentHTML('beforeend', s.data.data.html_3d)

          setTimeout(() => {
            let form = document.getElementsByTagName('form')[2]
            if (!form) {
              if (document.returnform) {
                form = document.returnform
              } else {
                form = document.getElementById('webform0')
                if (!form) {
                  alert(this.$t("3D Secure ödeme formu bulunamadı"))
                }
              }
            }

            form.submit()
          }, 100)

          this.endWaiting()
        }) */
          if (this.selectedCard.id === 'other' || !this.isHaveCards) {
            this.$refs.stripe.pay();
          } else {
            const basketForm = {
              product_codes: this.productCodes,
              promotion_codes: this.form.promotion_code,
            };
            if (this.appliedAmount) {
              basketForm.wallet_amount = this.appliedAmount;
            }
            basketForm.card_id = this.selectedCard.id;
            $axios.put('register/' + this.company.id + '/basket/pay', basketForm).then((s) => {
              this.$emit('pay');

              this.endWaiting();
            });
          }
        }
      });
    },

    informHubspot() {
      CompanyStore.dispatch('informHubspot', {
        name: this.company.users.data[0].name,
        surname: this.company.users.data[0].surname,
        email: this.company.users.data[0].email,
      });
    },
    completed() {
      this.informHubspot();
      this.$toasted.show(this.$t('AlertMessages.Ödemeniz başarıyla tamamlandı'), {
        duration: 60000,
      });
      // Callback to parent component
      // eslint-disable-next-line node/no-callback-literal
      callback(true);
    },
  },
  components: {
    IyzicoAgreementModal,
    FreePromotionAppliedModal,
    AcceptedCreditCardModal,
    Stripe,
    Promotion,
    CardSelection,
  },
};
</script>
<style lang="less">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
